<template lang="pug">
  .contact-color-crew.row
    .xs-12.md-7.md-offset-1
      p.slot-text.xs-f-medium.lg-f-large.max-at-tweak.color-slate
        slot

    .xs-12.md-3
      SupportCtas(:hideCtas='["email"]' :phone-number="$root.MRConfig.cancelSubPhone" :track-event-params="{ reason: cancelData.reason }")

</template>

<script>
  import { mapState } from 'vuex';
  import SupportCtas from "../../../SupportCtas";
  export default {
    name: 'ColorCrewContact',
    components: {
      SupportCtas
    },

    computed: {
      ...mapState('subscriptions', [
        'cancelData'
      ])
    }
  };
</script>

<style scoped lang="stylus">
  .contact-color-crew 
    background-color bg-color-info
    padding 2.5em 0

    .support-ctas
      margin-top 1em

    .slot-text
      padding 1em

    @media mq-mobile
      padding 1.5em 0

      .slot-text
        text-align center

    @media mq-tablet
      padding 2.75em 0

      .slot-text
        text-align center

</style>
